import { render } from "./table-cell-errors.vue?vue&type=template&id=71c0fcde"
import script from "./table-cell-errors.vue?vue&type=script&lang=js"
export * from "./table-cell-errors.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__